import { FC, HTMLAttributes, ReactNode } from 'react';
import clsx from 'clsx';

import styles from './index.module.css';

interface TableProps extends HTMLAttributes<HTMLTableElement> {
  children: ReactNode;
  className?: string;
}

export const Table: FC<TableProps> = ({ children, className, ...props }) => (
  <table className={clsx(styles.table, className)} {...props}>
    {children}
  </table>
);
